// src/components/SampleOrdersPage.jsx
import React from "react";
import AppNavBar from "../common/AppNavBar";
import SampleOrders from "./SampleOrders";

const SampleOrdersPage = () => (
  <>
    <AppNavBar fullWidth={true}/>
    {/* ensure content sits below the fixed navbar */}
    <div style={{ marginTop: "56px" }}>
      <SampleOrders />
    </div>
  </>
);

export default SampleOrdersPage;
